{
  "vitalsEntry": {
    "title": "生命表徵",
    "subtitle": "記錄及查閱生命表徵",
    "printLabel": "列印生命表徵",
    "recordSection": "記錄生命表徵",
    "save": "記錄生命表徵",
    "cancel": "取消",
    "saving": "記錄中...",
    "recordedSuccess": "生命表徵已成功記錄",
    "recordedError": "記錄生命表徵失敗",
    "invalidEncounter": "就診編號無效。",
    "historyTitle": "近期生命表徵",
    "loadingHistory": "載入生命表徵中...",
    "loadError": "載入生命表徵失敗。",
    "emptyHistory": "今次就診未有記錄生命表徵。",
    "morseTitle": "Morse 跌倒風險評估表",
    "bradenTitle": "Braden 壓瘡風險評估表",
    "riskScalesSaved": "風險評分已成功記錄",
    "riskScalesFailed": "生命表徵已儲存，但風險評分記錄失敗"
  },
  "vitals": {
    "systolic": "上壓",
    "diastolic": "下壓",
    "heartRate": "心跳",
    "respiratoryRate": "呼吸頻率",
    "temperature": "體溫",
    "oxygenSaturation": "血氧飽和度 (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "痛楚評分",
    "weight": "體重",
    "height": "身高",
    "bmi": "BMI",
    "rangeError": "{{field}}須介乎 {{min}} 至 {{max}} 之間",
    "placeholders": {
      "temperature": "例如：37.0",
      "heartRate": "例如：72",
      "respiratoryRate": "例如：16",
      "oxygenSaturation": "例如：98",
      "systolic": "例如：120",
      "diastolic": "例如：80",
      "weight": "例如：70.5",
      "height": "例如：175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "正常",
    "borderline": "邊緣",
    "abnormal": "異常",
    "critical": "危急"
  },
  "tableHeaders": {
    "dateTime": "日期/時間",
    "temperature": "體溫",
    "heartRate": "心跳",
    "respiratoryRate": "呼吸",
    "bloodPressure": "血壓",
    "oxygenSaturation": "SpO2",
    "weight": "體重",
    "height": "身高",
    "pain": "痛楚"
  },
  "io": {
    "title": "出入量",
    "addRecord": "新增記錄",
    "addRecordSection": "新增出入量記錄",
    "loading": "正在載入出入量記錄...",
    "loadError": "載入出入量記錄失敗。",
    "empty": "今次就診未記錄出入量。",
    "totals": {
      "intake": "總入量",
      "output": "總出量",
      "balance": "淨平衡",
      "totalsRow": "合計",
      "netLabel": "淨值"
    },
    "negativeWarning": "負平衡 — 請評估體液狀況",
    "columns": {
      "dateTime": "日期/時間",
      "type": "類型",
      "category": "類別",
      "amount": "量 (ml)",
      "notes": "備註"
    },
    "fields": {
      "type": "類型",
      "category": "類別",
      "amount": "量 (ml)",
      "notes": "備註"
    },
    "type": {
      "intake": "入量",
      "output": "出量"
    },
    "categoryPlaceholder": "選擇類別...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "選填備註...",
    "save": "儲存記錄",
    "cancel": "取消",
    "missingValueShort": "--",
    "toast": {
      "added": "已新增出入量記錄",
      "addFailed": "新增出入量記錄失敗",
      "missingFields": "請填寫必填欄位"
    }
  },
  "intake": {
    "oral": "口服",
    "iv": "IV",
    "bloodProducts": "血製品",
    "tpn": "TPN",
    "tubeFeeding": "鼻飼",
    "other": "其他"
  },
  "output": {
    "urine": "尿量",
    "drain": "引流",
    "emesis": "嘔吐物",
    "stool": "糞便",
    "bloodLoss": "失血",
    "ngSuction": "NG 抽吸",
    "other": "其他"
  },
  "wound": {
    "title": "傷口護理記錄",
    "subtitle": "就診 #{{id}} — 結構化傷口評估",
    "newAssessment": "新增傷口評估",
    "dimensionsTitle": "尺寸（厘米）",
    "woundBedTitle": "傷口床 (%)",
    "woundBedTotalWarning": "合計：{{total}}%（應為 100%）",
    "woundBedTotalOk": "合計：100%",
    "previousTitle": "過往評估",
    "empty": "今次就診未記錄傷口評估。",
    "invalidEncounter": "就診編號無效。",
    "save": "儲存評估",
    "savedSuccess": "已記錄傷口評估",
    "savedError": "儲存傷口評估失敗",
    "fields": {
      "woundType": "傷口類型",
      "location": "位置",
      "stage": "分期",
      "length": "長",
      "width": "闊",
      "depth": "深",
      "granulation": "肉芽組織",
      "slough": "腐肉",
      "eschar": "焦痂",
      "epithelial": "上皮",
      "drainageType": "滲液類型",
      "drainageAmount": "滲液量",
      "surroundingSkin": "周圍皮膚",
      "treatment": "處理方法",
      "painScore": "痛楚評分 (0-10)",
      "notes": "備註"
    },
    "placeholders": {
      "length": "例如：3.5",
      "width": "例如：2.0",
      "depth": "例如：0.5",
      "treatment": "描述已採用的傷口護理...",
      "notes": "其他觀察..."
    },
    "history": {
      "dimensionsLabel": "尺寸",
      "drainageLabel": "滲液",
      "painLabel": "痛楚",
      "treatmentLabel": "處理"
    },
    "stage": {
      "stage1": "1 期",
      "stage2": "2 期",
      "stage3": "3 期",
      "stage4": "4 期",
      "unstageable": "無法分期",
      "deepTissue": "深層組織損傷",
      "na": "N/A"
    },
    "drainageType": {
      "none": "無",
      "serous": "漿液性",
      "sanguineous": "血性",
      "serosanguineous": "漿液血性",
      "purulent": "膿性"
    },
    "drainageAmount": {
      "none": "無",
      "scant": "極少",
      "small": "少量",
      "moderate": "中等量",
      "large": "大量",
      "copious": "極多"
    },
    "woundType": {
      "pressure": "壓力性損傷",
      "surgical": "手術（傷口）",
      "diabetic": "糖尿病潰瘍",
      "venous": "靜脈潰瘍",
      "arterial": "動脈潰瘍",
      "traumatic": "創傷性",
      "skinTear": "皮膚撕裂傷",
      "other": "其他"
    },
    "location": {
      "sacrum": "骶部",
      "coccyx": "尾骨",
      "leftHeel": "左足踭",
      "rightHeel": "右足踭",
      "leftTrochanter": "左粗隆",
      "rightTrochanter": "右粗隆",
      "abdomen": "腹部",
      "leftLeg": "左腿",
      "rightLeg": "右腿",
      "back": "背部",
      "other": "其他"
    },
    "surroundingSkin": {
      "intact": "完整",
      "erythema": "紅斑",
      "macerated": "浸漬",
      "indurated": "硬結",
      "edematous": "水腫",
      "warm": "發熱",
      "discolored": "變色"
    }
  },
  "carePlan": {
    "title": "護理計劃",
    "addPlan": "新增護理計劃",
    "newPlan": "新建護理計劃",
    "createPlan": "建立計劃",
    "cancel": "取消",
    "empty": "此病人未記錄護理計劃。",
    "emptyGoals": "尚未訂定目標。",
    "goals": "目標",
    "addGoal": "新增目標",
    "saving": "儲存中...",
    "loading": "正在載入護理計劃...",
    "loadError": "載入護理計劃失敗。",
    "fields": {
      "title": "標題",
      "startDate": "開始日期",
      "targetDate": "目標日期",
      "description": "描述",
      "target": "目標值"
    },
    "placeholders": {
      "title": "例如：防跌計劃",
      "description": "目標描述",
      "target": "例如：30 日內無跌倒"
    },
    "history": {
      "startLabel": "開始",
      "targetLabel": "目標",
      "goalsLabel": "目標數"
    },
    "status": {
      "active": "進行中",
      "completed": "已完成",
      "cancelled": "已取消"
    },
    "goalStatus": {
      "inProgress": "進行中",
      "achieved": "已達成",
      "notAchieved": "未達成"
    },
    "toast": {
      "planCreated": "已建立護理計劃",
      "planCreateFailed": "建立護理計劃失敗",
      "goalAdded": "已新增目標",
      "goalAddFailed": "新增目標失敗",
      "planValidation": "標題及開始日期為必填項",
      "goalValidation": "描述及目標值為必填項"
    }
  }
}
